import { create } from 'zustand';

import { WfaLabelOptionsDistinctQuery } from 'src/apps/wfa/services/queries/label-options/WfaLabelOptionsDistinct.generated';
import { getLabelOptionsDistinct } from 'src/apps/wfa/services/WfaDashboardService';
import { Logger } from 'src/common/services/Logger';

//
interface WfaSessionsStore {
	labelOptions: WfaLabelOptionsDistinctQuery['wfa_session_run_labels'];
	isLabelOptionsLoading: boolean;
	getLabelOptions: () => Promise<void>;
	resetLabelOptions: () => void;
}

export const wfaSessionsPageStore = create<WfaSessionsStore>((set) => ({
	labelOptions: [],
	isLabelOptionsLoading: false,
	setIsLabelOptionsLoading: (isLabelOptionsLoading: boolean) => set({ isLabelOptionsLoading }),

	getLabelOptions: async () => {
		try {
			set({ isLabelOptionsLoading: true });
			const labelOptions = await getLabelOptionsDistinct();
			set({ labelOptions, isLabelOptionsLoading: false });
		} catch (error) {
			Logger.error('WfaSessionsStore -> getLabelOptions failed with an error:', error);
			set({ isLabelOptionsLoading: false });
			throw error;
		} finally {
			set({ isLabelOptionsLoading: false });
		}
	},
	resetLabelOptions: () => set({ labelOptions: [], isLabelOptionsLoading: false })
}));
